import { lazy, Suspense } from "react";
import { Switch, Route, Redirect } from "wouter";
import { queryClient } from "./lib/queryClient";
import { QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import NotFound from "@/pages/not-found";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Legal from "@/pages/Legal";
import AdminPage from "@/pages/Admin";
import { AdminSignInPage, SignInPage, SignUpPage } from "@/pages/AuthPages";
import { BrowserClerkProvider, clerkBasePath } from "@/components/ClerkAuthProvider";
import EarlyAccessApplication from "@/pages/EarlyAccessApplication";
import { PlatformAccessGate } from "@/components/PlatformAccessGate";

const LifecycleLab = lazy(() => import("@/pages/LifecycleLab"));

function Router() {
  return (
    <Switch>
      <Route path="/admin/sign-in/*?" component={AdminSignInPage} />
      <Route path="/sign-in/*?" component={SignInPage} />
      <Route path="/sign-up/*?" component={SignUpPage} />
      <Route path="/admin" component={AdminPage} />
      <Route path="/apply" component={EarlyAccessApplication} />
      <Route path="/" component={Home} />
      <Route path="/about" component={About} />
      <Route path="/legal" component={Legal} />
      <Route path="/app">
        <PlatformAccessGate>
          <Suspense fallback={<div className="min-h-screen bg-slate-950" />}>
            <LifecycleLab />
          </Suspense>
        </PlatformAccessGate>
      </Route>
      <Route component={NotFound} />
    </Switch>
  );
}

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        {typeof window === "undefined" ? (
          <Router />
        ) : (
          <BrowserClerkProvider>
            <Router />
          </BrowserClerkProvider>
        )}
      </TooltipProvider>
    </QueryClientProvider>
  );
}

export default App;
